import React, { useState, useMemo, useEffect } from 'react'
import { Button, Card, CardBody, CardHeader, Container, Modal, ModalBody, ModalHeader, Row, UncontrolledTooltip } from 'reactstrap'
import UploadFile from './UploadFile'
import { Link, useNavigate } from 'react-router-dom'
import { FontAwesomeIcon } from "@fortawesome/react-fontawesome"
import { faArrowLeft } from "@fortawesome/free-solid-svg-icons"
import TableContainer from 'components/Common/TableContainer'
import { useSelector } from 'react-redux'
import { createSelector } from 'reselect'
import {
    SrNo,
    FileName,
    Description,
    FileType
} from './KnowledgeCenterCol'
import { toast } from 'react-toastify'
import Spinners from 'components/Common/Spinner'
import { useDispatch } from 'react-redux'
import { getKnowledgeCenterDoc, rmKnowledgeCenterFile } from 'store/actions'
const ManageKnowledgeCenter = () => {
    const navigate = useNavigate();
    const dispatch = useDispatch();

    const [showUploadFileModal, setShowUploadFileModal] = useState(false)
    const [showDeleteFileModal, setShowDeleteFileModal] = useState(false)
    const [selectedFile, setSelectedFile] = useState(null)

    const toggleUploadFileModal = () => {
        setShowUploadFileModal(!showUploadFileModal)
    }

    const toggleDeleteFileModal = (id) => {
        setSelectedFile(id)
        setShowDeleteFileModal(!showDeleteFileModal)
    }

    const handleDeleteFile = () => {
        dispatch(rmKnowledgeCenterFile({ id: selectedFile }))
        setSelectedFile(null)
        setShowDeleteFileModal(!showDeleteFileModal)
    }

    // Getting Redux State
    const KnowledgeCenterReducer = state => state.KnowledgeCenterReducer
    const KnowledgeCenterProperty = createSelector(
        KnowledgeCenterReducer,
        KnowledgeCenterStore => ({
            errors: KnowledgeCenterStore.error,
            successMsg: KnowledgeCenterStore.successMsg,
            Loading: KnowledgeCenterStore.Loading,
            uploadedFiles: KnowledgeCenterStore.uploadedFiles
        })
    )

    const { errors, successMsg, Loading, uploadedFiles } =
        useSelector(KnowledgeCenterProperty)

    useEffect(() => {
        if (errors && errors !== "") {
            toast.error(errors)
        }
        if (successMsg && successMsg !== "") {
            toast.success(successMsg)
            dispatch(getKnowledgeCenterDoc())
        }
    }, [errors, successMsg])

    useEffect(() => {
        dispatch(getKnowledgeCenterDoc())
    }, [])


    const columns = useMemo(
        () => [
            {
                Header: "Sr No",
                accessor: (row, i) => i + 1,
                filterable: true,
                Cell: cellProps => {
                    return <SrNo {...cellProps} />
                },
            },
            {
                Header: "File",
                accessor: "fileName",
                filterable: true,
                Cell: cellProps => {
                    return <>{cellProps.value}</>;
                },
            },
            {
                Header: "File Type",
                accessor: "fileType",
                filterable: true,
                Cell: cellProps => {
                    return <FileType {...cellProps} />
                },
            },

            {
                Header: "Description",
                accessor: "description",
                filterable: true,
                Cell: cellProps => {
                    return <Description {...cellProps} />
                },
            },
            {
                Header: "Action",
                accessor: "action",
                disableFilters: true,
                Cell: cellProps => {
                    return (
                        <>
                            <ul className="list-unstyled hstack gap-1 mb-0">
                                 <li
                                    data-bs-toggle="tooltip"
                                    data-bs-placement="top"
                                    title="DownLoad"
                                    id={`Downloadtooltip-${cellProps.row.original.id}`}
                                    className="btn btn-sm btn-soft-info"
                                >
                                    <a href={cellProps.value} download>
                                        <i className="mdi mdi-download"></i>
                                    </a>

                                    <UncontrolledTooltip
                                        placement="top"
                                        target={`Downloadtooltip-${cellProps.row.original.id}`}
                                    >
                                        DownLoad
                                    </UncontrolledTooltip>
                                </li> 

                                <li>
                                    <Link
                                        to="#"
                                        className="btn btn-sm btn-soft-danger"
                                        onClick={() =>  toggleDeleteFileModal(cellProps.row.original.id)
                                        }
                                        id={`deletetooltip-${cellProps.row.original.id}`}
                                    >
                                        <i className="mdi mdi-delete-outline" />
                                        <UncontrolledTooltip
                                            placement="top"
                                            target={`deletetooltip-${cellProps.row.original.id}`}
                                        >
                                            Delete Files
                                        </UncontrolledTooltip>
                                    </Link>
                                </li>


                            </ul>
                        </>
                    )
                },
            },
        ],[])
   
    return (
        <div className='page-content'>
            <Container fluid={true}>
                {
                    Loading ? <Spinners /> :

                        <Card>
                            <CardBody>
                                <div className='d-flex justify-content-between align-items-center'>
                                    {/* <Button
                                        onClick={() => navigate(-1)}
                                    >
                                        <FontAwesomeIcon icon={faArrowLeft} className="back-arrow" />
                                    </Button> */}
                                    <p className='fs-2 mt-1'>Knowledge Center</p>

                                    <Button color='primary' onClick={toggleUploadFileModal}> Upload document</Button>
                                </div>

                                <div className='mt-5'>

                                    <TableContainer
                                        columns={columns}
                                        data={uploadedFiles}
                                        isGlobalFilter={true}
                                        isAddOptions={false}
                                        // handleJobClicks={handleJobClicks}
                                        isJobListGlobalFilter={false}
                                        isPagination={true}
                                        iscustomPageSizeOptions={true}
                                        isShowingPageLength={true}
                                        customPageSize={15}
                                        tableClass="table-bordered align-middle nowrap mt-2"
                                        paginationDiv="col-sm-12 col-md-7"
                                        pagination="pagination justify-content-end pagination-rounded"
                                    />
                                </div>
                            </CardBody>
                        </Card>
                }
                <Modal isOpen={showUploadFileModal} toggle={toggleUploadFileModal} >
                    <ModalHeader tag={"h4"} toggle={toggleUploadFileModal}>
                        Upload Fiies
                    </ModalHeader>
                    <ModalBody>
                        <UploadFile toggleUploadFileModal={toggleUploadFileModal} />
                    </ModalBody>
                </Modal>

                {/* Delete FIle Modal */}
                <Modal isOpen={showDeleteFileModal} toggle={() => setShowDeleteFileModal(!showDeleteFileModal)} >
                    <ModalHeader tag={"h4"} toggle={() => setShowDeleteFileModal(!showDeleteFileModal)}>
                        Are You Sure ?....
                    </ModalHeader>
                    <ModalBody>
                        <p className='fs-5'>Do you wants to delete this file.</p>
                        <div className='d-flex justify-content-between p--1'>
                            <Button color='danger' onClick={() => handleDeleteFile()}>Delete</Button>
                            <Button color='primary' onClick={() => setShowDeleteFileModal(!showDeleteFileModal)}>Cancel</Button>
                        </div>
                    </ModalBody>
                </Modal>
            </Container>
        </div>
    )
}

export default ManageKnowledgeCenter